import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Divider, Fade, Snackbar, Stack, Typography } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";



function CanjeDetallePage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const stateToken = useSelector(state => state.reducerGlobal.token);

    const params = useParams();

    const { id } = params;
    console.log("id", id);



    useEffect(() => {
        if (id) {
            if (stateToken) {
                // handleDetalleEvento();
                setTimeout(() => {
                    setCargando(true);
                }, 1000);
            }
        } else {
            setTimeout(() => {
                setCargando(true);
            }, 1000);
        }
    }, [id, stateToken]);




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };










    return (
        <HeaderCustom>
            <div style={{
                marginTop: Padding.P2,
                padding: Padding.P2,
            }}>

                <div style={{
                    backgroundColor: PaletaColor.BLANCO,
                    borderRadius: Padding.P1,
                    padding: Padding.P3,
                }}>
                    {cargando ? (
                        <div style={{}}>
                            <Fade in={true} timeout={1000}>
                                <div>
                                    <Typography variant={'h5'} style={{ marginBottom: Padding.P2 }}>
                                        Canje
                                    </Typography>

                                    <div style={{ width: 700, padding: Padding.P2, borderRadius: Padding.P1, borderWidth: 1, borderColor: PaletaColor.COLOR_BACKGROUND_GRIS_CLARO, borderStyle: 'solid' }}>
                                        <Typography variant={'body1'} align="center">
                                            Luciano Armoa
                                        </Typography>

                                        <Typography variant={'body1'} align="center" color={PaletaColor.COLOR_BACKGROUND_GRIS} style={{ marginBottom: Padding.P2 }}>
                                            1234
                                        </Typography>




                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                                                <Typography variant={'body1'} fontWeight={"bold"}>
                                                    Promoción
                                                </Typography>
                                            </div>

                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography variant={'body1'} color={PaletaColor.COLOR_BACKGROUND_AZUL_CLARO} style={{ marginBottom: Padding.P2 }}>
                                                    Paseo Plus 2024
                                                </Typography>
                                            </div>
                                        </div>



                                        <Divider style={{ marginBottom: Padding.P2 }} />


                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                                                <Typography variant={'body1'} fontWeight={"bold"}>
                                                    Local
                                                </Typography>
                                            </div>

                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography variant={'body1'} color={PaletaColor.COLOR_BACKGROUND_AZUL_CLARO} style={{ marginBottom: Padding.P2 }}>
                                                    Josefina - MODA Y NEGOCIOS S.A
                                                </Typography>
                                            </div>
                                        </div>





                                        <Divider style={{ marginBottom: Padding.P2 }} />


                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                                                <Typography variant={'body1'} fontWeight={"bold"}>
                                                    Monto Canje
                                                </Typography>
                                            </div>

                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography variant={'body1'} color={PaletaColor.COLOR_BACKGROUND_AZUL_CLARO} style={{ marginBottom: Padding.P2 }}>
                                                    786.923
                                                </Typography>
                                            </div>
                                        </div>









                                        <Divider style={{ marginBottom: Padding.P2 }} />


                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                                                <Typography variant={'body1'} fontWeight={"bold"}>
                                                    Fecha
                                                </Typography>
                                            </div>

                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography variant={'body1'} color={PaletaColor.COLOR_BACKGROUND_AZUL_CLARO} style={{ marginBottom: Padding.P2 }}>
                                                    2024-10-19 21:42:29
                                                </Typography>
                                            </div>
                                        </div>







                                        <Divider style={{ marginBottom: Padding.P2 }} />


                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                                                <Typography variant={'body1'} fontWeight={"bold"}>
                                                    ID Canje
                                                </Typography>
                                            </div>

                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography variant={'body1'} color={PaletaColor.COLOR_BACKGROUND_AZUL_CLARO} style={{ marginBottom: Padding.P2 }}>
                                                    9760
                                                </Typography>
                                            </div>
                                        </div>







                                        <Divider style={{ marginBottom: Padding.P2 }} />


                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                                                <Typography variant={'body1'} fontWeight={"bold"}>
                                                    Operación reversada
                                                </Typography>
                                            </div>

                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography variant={'body1'} color={PaletaColor.COLOR_BACKGROUND_AZUL_CLARO} style={{ marginBottom: Padding.P2 }}>
                                                    No
                                                </Typography>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </Fade>
                        </div>
                    ) : <SkeletonLoading />
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default CanjeDetallePage;